import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import MenuItem from './MenuItem';

const MenuItems = ({ items, activeClass }) => (
  <nav className="menu-items">
    <ul className="menu-items__menu">
      {map(items,
        (item) =>(
        <MenuItem
          className="menu-items__menu-item"
          item={item}
          key={item.id}
          activeClass={activeClass}/>
        )
      )}
    </ul>
  </nav>
);

MenuItems.propTypes = {
  items: PropTypes.array,
  activeClass: PropTypes.string,
};

export default MenuItems;
